export enum Cookies {
  GA_CLIENT_ID = "_ga",
}
